import React from 'react';
import {Text, View, Dimensions, StyleSheet} from 'react-native';
import HomeHeader from '../../components/HomeHeader';
import {Col, Container, Row} from 'react-bootstrap';
import Accordion from '../../components/Accordion';

const HEIGHT = Dimensions.get('window').height;

export default function FaqScreen(props) {
  
  return (
    <View
      style={{
        height: HEIGHT,
      }}>
      <HomeHeader navigation={props.navigation} />
      <Container style={{marginTop: 30}}>
        <Row>
          <Col md={2}></Col>
          <Col md={8}>
            <View>
              <Text style={styles.headerTitle}>FAQs</Text>
              <Accordion name="How do I find my subscriber ID?">
                <Text style={styles.faqAnswer}>
                  You can find your Subscriber ID easily using any of the below
                  options:​
                </Text>
              </Accordion>
              <Accordion name="How to access Ulka Remote?">
                <Text style={styles.faqAnswer}>
                  You can find your Subscriber ID easily using any of the below
                  options:​
                </Text>
              </Accordion>
              <Accordion name="How can I change/update my Registered Mobile Number?">
                <Text style={styles.faqAnswer}>
                  You can find your Subscriber ID easily using any of the below
                  options:​
                </Text>
              </Accordion>
              <Accordion name="What are the various ways in which I can recharge my account?">
                <Text style={styles.faqAnswer}>
                  You can find your Subscriber ID easily using any of the below
                  options:​
                </Text>
              </Accordion>
            </View>
          </Col>
          <Col md={2}></Col>
        </Row>
      </Container>
    </View>
  );
}

const styles = StyleSheet.create({
  faqAnswer: {
    color: 'lightgray',
    marginTop: 15,
    marginLeft: 20,
  },
  headerTitle: {
    color: 'lightgray',
    letterSpacing: 1,
    fontWeight: 'bold',
    fontSize: 30,
    alignSelf: 'center',
    marginBottom: 30,
  },
});
